import { useFeatureFlagValueBool } from "./useFeatureFlagValue";

export const useStackChatEnabled = () => {
  return useFeatureFlagValueBool("dash_2025_03_21_stack_chat");
};
